module.exports = __webpack_public_path__ + "static/media/logo-app.af7d24a2.png";